export default __webpack_public_path__ + "static/FavoriteVehicles-e5fadf9264b8fcd3141448870c1f2c59.jpg";